import { Builder } from '@builder.io/sdk';
import { IconCard } from './IconCard';
import { IconNames, FillColours } from '../Icon/Icon';
import { BuilderInputOptions } from '@/types/builder';

export const IconCardInputs = [
  {
    name: 'title',
    type: 'string',
    defaultValue: 'Enter a title',
  },
  {
    name: 'icon',
    type: 'enum',
    defaultValue: IconNames[0],
    enum: IconNames.map((n) => ({
      label: n,
      value: n,
    })),
  },
  {
    name: 'fillColour',
    type: 'enum',
    defaultValue: FillColours[0],
    enum: FillColours.map((n) => ({
      label: n,
      value: n,
    })),
  },
  {
    name: 'vCentre',
    friendlyName: 'Vertically centre content',
    type: 'boolean',
    defaultValue: false,
  },
  {
    name: 'contents',
    type: 'richText',
    defaultValue: '<p>Enter the content here...</p>',
  },
];

const IconCardConfig = {
  name: 'IconCard',
  friendlyName: 'Card with Icon',
  defaultStyles: {
    margin: '0',
    flexGrow: '1',
    flexShrink: '1',
    flexBasis: '100%',
  },
  inputs: [
    ...IconCardInputs,
    {
      name: 'twoColumns',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'secondaryContents',
      type: 'richText',
      showIf: (options: BuilderInputOptions) => !!options.get('twoColumns'),
    },
  ],
};

Builder.registerComponent(IconCard, IconCardConfig);
